import { render } from "./PDFJSViewer.vue?vue&type=template&id=73bcef97&scoped=true"
import script from "./PDFJSViewer.vue?vue&type=script&lang=js"
export * from "./PDFJSViewer.vue?vue&type=script&lang=js"

import "./PDFJSViewer.vue?vue&type=style&index=0&id=73bcef97&scoped=true&lang=css"

import exportComponent from "/Users/timtsang/VueProject/test-2-2/test-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73bcef97"]])

export default __exports__